<template>
  <!-- 充值弹窗 -->
  <el-dialog title=""
    :visible.sync="visible"
    class="withdrawal-components"
    :before-close="close"
    width="432px">
      <div class="content">
        <div class="content-title">提现申请</div>
        <div class="content-body">
          <el-row :gutter="20">
            <el-col :span="5">
              <div class="label">银行卡</div>
            </el-col>
            <el-col :span="19">
              <div class="">
                  <el-select
                    v-model="formInline.bank_id"
                    :popper-append-to-body="false"
                    class="consumer-select"
                    placeholder="请选择银行卡"
                    size="medium"
                    clearable
                    style="width: 290px">
                   <el-option
                    v-for="(item,index) in cards"
                    :key="index"
                    :label="item.bank"
                    :value="item.id">
                   </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="5">
              <div class="label">提现金额</div>
            </el-col>
            <el-col :span="19">
              <div class="">
                  <el-input
                    v-model="formInline.apply_amount"
                    size="medium"
                    style="width:290px"
                    placeholder="100-50000之间"></el-input>
              </div>
              <div class="re-div">可提现金额：<span>1988</span></div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="5">
              <div class="label">手机号码</div>
            </el-col>
            <el-col :span="19">
              <div>
                  <el-input
                    :disabled="true"
                    size="medium"
                    style="width:290px"
                    v-model="userInfo.formatPhone"
                    placeholder=""></el-input>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="5">
              <div class="label">验证码</div>
            </el-col>
            <el-col :span="19">
              <div style="position:relative;">
                  <el-input
                    size="medium"
                    style="width:290px"
                    v-model="formInline.smscode"
                    placeholder="请输入验证码"></el-input>
                    <div class="send-btn" @click="setMessageCode">点击发送</div>
              </div>
            </el-col>
          </el-row>

        </div>
      </div>
      <div slot="footer"
         class="dialog-footer_one"
         @click="commit">
        <div>确认提现</div>
      </div>
  </el-dialog>

</template>

<script>
  // import {bankList} from "@/util/config"
  import { mapState, mapMutations } from "vuex"
  // console.log("bankList: ",bankList);
  import { post } from "../../util/http";
  export default{
    computed: {
      ...mapState([
        "userInfo",
        "appConfig"
      ])
    },
    watch:{

    },
    data(){
      return {
        visible : false,
        card : "",
        cards : [],
        formInline:{
          apply_amount: "",
          bank_id: "",
          smscode: "",
        }
      }
    },
    created(){
      this.getCards();
      // console.log("this.userInfo",this.userInfo);
    },
    methods: {
      open(){
        this.visible = true;
      },
      close(){
        this.visible = false;
        this.formInline = {
          apply_amount: "",
          bank_id: "",
          smscode: "",
        };
      },
      check(){
        let can = true;
        return can;
      },
      getCards(){
        post({
          url: "/api/user/getBanks"
        }).then(({ data: { data } })  => {
          data.forEach(v=>{
            v.small_card = v.card.substr(-4);
          })
          this.cards = data;
        })
        .catch(err=>{
          console.log(err);
        })
      },
      check(){
        if(this.formInline.hasOwnProperty('apply_amount')&&this.formInline.bank_id){

        }else{
          this.$message({
            showClose: true,
            message: '请选择银行卡',
            type: 'warning'
          });
          return false;
        }
        if(this.formInline.hasOwnProperty('apply_amount')&&this.formInline.apply_amount){
          var re = /^[0-9]+.?[0-9]*/ig;//判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
          if (!re.test(this.formInline.apply_amount)){
            this.$message({
              showClose: true,
              message: '请正确输入提现金额',
              type: 'warning'
            });
            return false;
          }
          let apply_amount = parseFloat(this.formInline.apply_amount);
          if(!(apply_amount>=100 && apply_amount<=5000)){
            this.$message({
              showClose: true,
              message: '提现金额必须100-5000之间',
              type: 'warning'
            });
            return false;
          }
        }else{
          this.$message({
            showClose: true,
            message: '请输入提现金额',
            type: 'warning'
          });
          return false;
        }
        if(this.formInline.hasOwnProperty('smscode')&&this.formInline.smscode){
          
        }else{
          this.$message({
            showClose: true,
            message: '请输入验证码',
            type: 'warning'
          });
          return false;
        }
        return true;
      },
      commit(){
        if(!this.check()){ return; }
        // console.log("this.formInline",this.formInline);
        let apply_amount = 0;
        if(this.formInline.hasOwnProperty('apply_amount')&&this.formInline.apply_amount){
          apply_amount = parseFloat(this.formInline.apply_amount);
        }
        let data ={
          ...this.formInline,
          apply_amount
        };
        post({
          url: "/api/withdraw/add",
          data
        }).then(( { data: { data,status=1 } })  => {
          if(status==0){
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            });
          }else{
            this.$message({
              showClose: true,
              message: '操作失败',
              type: 'warning'
            });
          }
          this.close();
        })
        .catch(err=>{
          console.log("err: ",err);
          this.close();
        })
      },
      setMessageCode() {
        let datainfo = {
          mobile: this.userInfo.account
        };
        post({
          url: "/api/user/sendVerifyCode",
          data: datainfo
        }).then(({ data: { data,status=1}})=>{
          if(status==0){
            this.$message({
              showClose: true,
              message: '短信已发送',
              type: 'success'
            });
          }else{
            this.$message({
              showClose: true,
              message: '发送失败',
              type: 'warning'
            });
          }
        })
        .catch(err=>{
        })
      }


    }
  }
</script>

<style  scoped lang="stylus">
  .withdrawal-components{
    z-index:1;
    border-radius: 8px;
    /deep/{
      .el-dialog__header{
        padding-top : 0px;
      }
      .el-dialog__headerbtn .el-dialog__close{
        color : #999999;
        font-size : 24px;
      }
      .el-input--suffix .el-input__inner{
        background: #F7F7F7;
      }
      .el-input__inner{
        border-color : #f0f0f0 !important;
        //color : #333333 !important;
        &:hover{
          border-color : #f0f0f0 !important;
        }
      }
      .el-select .el-input.is-focus .el-input__inner{
        border-color : #f0f0f0;
      }
      .el-select .el-input__inner:focus{
        border-color : #f0f0f0;
      }
      .el-range-input {
        background: #f7f7f7 !important;
        //color: #333333 !important;
      }
      .el-date-editor {
        border-color : #f0f0f0 !important;
        background: #f7f7f7 !important;
      }
      .el-date-table td.start-date span, .el-date-table td.end-date span{
        // background-color : #26D99D !important;
      }
      .el-input__inner{
        background: #f7f7f7 !important;
        border-color : #f0f0f0;
        //color : #333333;
      }
      .el-input__inner:focus{
        border-color : #f0f0f0;
      }
      .el-select-dropdown__item{
        text-align : center;
      }
      .el-select-dropdown__item.selected,.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
        background-color : rgba(38,217,157,0.10);
        color: #333333;
      }
    }
    .el-row{
      padding : 10px 0px;;
    }
    .content{
      padding : 30px;
      .content-title {
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 550;
        padding-bottom : 30px;
      }
      .label{
        height : 36px;
        line-height : 36px;
      }
      .re-div{
        height : 17px;
        line-height : 17px;
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        padding-top:2px;
        span{
          color : #26D99D;
          font-weight : 600;
        }
      }
      .send-btn{
        color : #ffffff;
        background: #DCB273;
        border-radius: 16px;
        position : absolute;
        padding : 5px 10px;
        right : 10px;
        top : 50%;
        transform : translateY(-50%);
        cursor : pointer;
      }
    }

    .dialog-footer_one>div{
      height: 40px;
      background: #26D99D;
      border-radius: 20px;
    }

  }
</style>
